// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__hTt-Y","brandLogoWrapper":"footer_brandLogoWrapper__2vNUs","brandLogo":"footer_brandLogo__3On0R","menu":"footer_menu__2VNzE","allRightsReserved":"footer_allRightsReserved__3Mn3L","spacer":"footer_spacer__11Awq","logos":"footer_logos__xUtfp"};
    if(module.hot) {
      // 1785568557203
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  